import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './GameDetails.css';
import { useNavigate } from 'react-router-dom';

const GameDetails = () => {
    const [games, setGames] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchGames = async () => {
            try {
                const response = await axios.get('/api/admin/games/last-month');
                setGames(response.data['games']);
            } catch (error) {
                navigate("/");
            }
        };

        fetchGames();
    }, [navigate]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="game-details">
            <h1>Games Created Last Month</h1>
            <table>
                <thead>
                    <tr>
                        <th>House Name</th>
                        <th>Owner Name</th>
                        <th>Owner Email</th>
                        <th>Event Date</th>
                        <th>Event Name</th>
                        <th>Number of Players</th>
                        <th>Total Buy Ins</th>
                    </tr>
                </thead>
                <tbody>
                    {games.map((game, index) => (
                        <tr key={index}>
                            <td>{game.houseDescription}</td>
                            <td>{game.ownerName}</td>
                            <td>{game.ownerEmail}</td>
                            <td>{formatDate(game.eventDate)}</td>
                            <td>{game.gameDescription}</td>
                            <td>{game.numPlayers}</td>
                            <td>{game.totalBuyIns}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default GameDetails;
